import React, { useState, useEffect } from 'react'
import { updateData, addData, getIdData } from "../../../lib/studentpersonalquestion"

export default function GlobalQuestionEdit({ value, setValue, id, studentId, questionId }) {

  const [newAnswer, setNewAnswer] = useState(value);
  const [show, setShow] = useState(false);

  //console.log("edit",id,questionId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("Answer", newAnswer);
    setValue(newAnswer);

    if (id == 0) {
      console.log("Yeni");
      await addData({
        studentId: studentId,
        questionId: questionId,
        isAnswer: true,
        studentAnswer: newAnswer
      });
    }
    else {
      //console.log("Eski");
      await updateData({
        id: id,
        studentAnswer: newAnswer
      });
    }
    setShow(true);
  }

  useEffect(() => {
    setNewAnswer(value);
  }, [value])

  const messages = () => {
    return (<div className="alert alert-success alert-dismissible fade show" role="alert">
      <strong>Data Updated...</strong> {/*You should check in on some of those fields below.*/}
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>)
  }

  return (
    <form method="post" onSubmit={handleSubmit}>
      {show ? messages() : ""}
      <div className="col-12">
        <div className="form-group">
          <textarea className="form-control" value={newAnswer}
            onChange={(e) => setNewAnswer(e.target.value)} rows="4"></textarea>
        </div>
      </div>
      <div className="update-profile d-flex justify-content-between">
        <button type="submit" className="btn btn-primary">
          Update Answer
        </button>
      </div>
    </form>
  )
}
